import * as Types from '../model/types';
import * as OpTypes from '../opTypes';
import * as Graph from '../graph';

// Not exposed, we should have more specific ops that
// get specific kinds of tags
export const opGetTag = Graph.makeOp({
  hidden: true,
  name: 'get-tag',
  argTypes: {
    value: Types.maybe(Types.taggedValue('any', 'any')),
  },
  description: `Returns the tag of a ${Graph.docType('tagged')}`,
  argDescriptions: {
    value: `The ${Graph.docType('tagged')}`,
  },
  returnValueDescription: `The tag of the ${Graph.docType('tagged')}`,
  returnType: inputs => {
    return OpTypes.mappableNullable(inputs.value.type, t => {
      if (Types.isUnion(t)) {
        // Treating this as an error for now. It is likely the result
        // of a problem elsewhere. We should always have a specific single
        // tag, rather than a union of tags. TaggedValues are meant to
        // convey path information, you should never need to try two
        // different paths.
        throw new Error('invalid');
        // return Types.union(
        //   t.members.map(mem => {
        //     if (!Types.isTaggedValue(mem)) {
        //       throw new Error('invalid');
        //     }
        //     return mem.tag;
        //   })
        // );
      }
      if (!Types.isTaggedValue(t)) {
        throw new Error('invalid');
      }
      return t.tag;
    });
  },
  resolver: inputs => OpTypes.mappableNullableVal(inputs.value, v => v._tag),
});
